import { render, staticRenderFns } from "./ReviewSites.vue?vue&type=template&id=36f70f5c&scoped=true"
import script from "./ReviewSites.vue?vue&type=script&lang=js"
export * from "./ReviewSites.vue?vue&type=script&lang=js"
import style0 from "./ReviewSites.vue?vue&type=style&index=0&id=36f70f5c&prod&lang=css"
import style1 from "./ReviewSites.vue?vue&type=style&index=1&id=36f70f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f70f5c",
  null
  
)

export default component.exports